<template>
    <div id="body" class="nlp-event">
        <div class="event-left">
            <div class="font-gray">
                请输入文本：
                <button @click="getExample()">
                    随机示例
                </button>
                <div class="num-limit">
                    已经输入<span>{{ len }}</span>字
                </div>
            </div>
            <div class="content-input" ref="inputContent" @input="typing" contenteditable="true" v-html="content"></div>

            <div align="center">
                <button @click="predict_ljx()" size="small" :loading="loading"
                    class="el-button btn-large el-button--primary el-button--medium">
                    {{ loading ? '加载中' : '开始分析' }}
                </button>
            </div>
            <!-- <textarea v-model="content" maxlength="1000"></textarea> -->
        </div>
        <div class="event-right">
            <div style="height: 350px;overflow: auto;">

                <template v-for="(item) in tableData" v-bind:key="item">
                    <el-card class="event-card" shadow=hover>
                        <div class="table-title">
                            <div class="event-type" v-bind:style="getStyle(item.event_type)">
                                {{ item.event_type }}
                            </div>
                        </div>

                        <el-table :data="item.arguments" :show-header=false stripe style="width: 100%;">
                            <el-table-column prop="role" align="center"></el-table-column>
                            <el-table-column prop="argument" align="center"></el-table-column>
                        </el-table>
                    </el-card>
                </template>

            </div>
        </div>
    </div>
</template>


<script>

    export default {
        name: 'Extract',
        data() { 
             return {
                len: 0,
                loading: false,
                content: '',
                tableData: {},
                eid: 0, // 事例文档id
             }
        },
        mounted() {
            this.getExample()
        },
        methods: {
            typing(el) {
                if (this.$refs.inputContent.innerText.length >= 10000) {
                    el.target.innerHTML = this.$refs.inputContent.innerText.substring(0, 1000)
                    var _div = document.querySelector('.content-input');
                    var range = document.createRange();

                    range.selectNodeContents(_div);
                    range.collapse(false);

                    var sel = window.getSelection();
                    sel.removeAllRanges();
                    sel.addRange(range);
                }
                this.len = el.target.innerText.length;
            },
            checkLength() {
                this.len = this.content.length
            },
            getStyle(et) {
                const EVENT_COLOR = new Map([['公司上市', '#34a853'], ['股东减持', '#4285f4'], ['股东增持', '#f538a0'], ['企业收购', '#185abc'], ['企业融资', '#b31412'], 
                ['股份回购', '#f29900'], ['质押', '#ea4335'], ['解除质押', '#9aa0a6'], ['企业破产', '#ffd700'], ['亏损', '#000000'], ['被约谈', '#663399'], ['高管变动', 'ff6347']])
                return {
                    'background-color': EVENT_COLOR.get(et)
                }
            },
            predict_ljx() {
                this.content = this.$refs.inputContent.innerText
                if (!this.content) {
                    this.$message({
                        message: "请输入要分析的文本",
                        type: 'warning'
                    });
                    return
                }
                const that = this
                this.tableData = {}
                this.loading = true

                // 面向演示直接get获取数据
                this.axios.get('/example', { params: { textNo: this.eid } })
                    .then(function (response) {
                        console.log(response)
                        that.loading = false
                        if (response.data && 200 == response.status) {
                            let result = response.data
                            that.content = result.formatContent
                            that.tableData = result.event_list
                        } else {
                            return null;
                        }
                    }).catch(function (error) {
                        console.log(error)
                    })

                {/* this.axios.post('/predict', {
                    'text': this.content,
                }).then(function (resp) {
                    that.loading = false
                    if (resp.data) {
                        console.log(resp.data.event_list)
                        resp.data={}

                        that.tableData = JSON.parse(resp.data.event_list, function(key, value){return value;})
                        // 需要些方法，去做转换，按照坐标，span的颜色由白色变为随机颜色
                        //that.content = resp.data.data.formatContent
                        // formatContent: "<span style=\"color:#ffffff;background-color:#22BCB8\">2021年1月</span><span style=\"color:#ffffff;background-color:#106ECE\">蔚来</span>在NIODAY发布第四款量产车型<span style=\"color:#ffffff;background-color:#05CF6D\">ET7</span>，搭载公司自研的自动驾驶技术平台NT2.0，预计2022Q1交付。"
                    }
                }).catch(function (error) {
                    console.log(error)
                    that.loading = false
                    that.$message({
                        message: '网络异常，请稍后再试',
                        type: 'warning'
                    });
                }); */}

            },
            getExample() {
                let that = this

                // 面向演示get要传一个随机数
                const EXAMPLE_CNT = 6 // 例子数，注意和mock里保持一致
                this.eid = Math.floor(Math.random()*EXAMPLE_CNT)

                this.axios.get('/example', { params: { textNo: this.eid } })
                    .then(function (response) {
                        console.log(response)
                        if (response.data && 200 == response.status) {
                            let result = response.data
                            that.content = result.event_list[0].text
                            that.checkLength()
                        } else {
                            return null;
                        }
                    }).catch(function (error) {
                        console.log(error)
                    })
            }

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #body {
        line-height: 1.5 !important;
        color: #333;
        font-family: PingFangSC-Light, tahoma, arial, microsoft yahei;
        font-size: 12px !important;
        padding: 4px;
    }

    .nlp-event {
        width: 1180px;
        height: 360px;
        margin: 0 auto;
        background-color: #fff;
    }

    .nlp-event * {
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }

    .event-left,
    .event-right {
        width: 50%;
        height: 100%;
        float: left;
    }

    .event-left {
        position: relative;
    }

    .event-right .table-title {
        display: block;
        height: 48px;
        padding: 0 20px;
        background-color: #FFF;
    }

    .event-right .event-card {
        margin: 6px;
    }

    .event-right .table-title .event-type {
        font-size: 15px;
        font-weight: bold;
        border-radius: 2px;
        color: #FFFFFF;
        float: right;
        margin: -20px -40px 0 0;
        padding: 10px 24px;
        background-color: #FF9000;
    }

    .event-left .font-gray {
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: #999999;
        text-align: left;
        text-indent: 14px;
    }

    .event-left .font-gray button {
        border: none;
        color: #FF9000;
        font-size: 14px;
        outline: none;
        background-color: #fff;
        cursor: pointer;
    }

    .event-left .font-gray .num-limit {
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: #999999;
        text-indent: 22px;
        display: inline-block;
        float: right;
        margin-right: 20px;
    }

    .event-left .font-gray .num-limit span {
        color: #FF9000;
    }

    .event-left .content-input {
        width: 100%;
        height: 225px;
        border: none;
        resize: none;
        padding: 10px;
        color: #606266;
        font-size: 14px;
        outline: none;
        overflow: auto;
        margin-bottom: 5px;
    }

    .event-left .rule-form button {
        width: 103px;
        height: 32px;
        border: 1px solid rgba(234, 73, 84, 0.5);
        float: right;
        margin-right: 20px;
        border-radius: 5px;
        outline: none;
        background-color: #fff;
    }

    .event-right {
        border-left: 1px solid #dadada;
    }

    .rule-form {
        /* margin-right: 20px; */
        border-bottom: 1px solid #dadada;
    }

    /* .el-form-item--mini.el-form-item, */
    .el-form-item--small.el-form-item {
        margin-bottom: 10px;
    }

    .el-form-item__label,
    .el-form-item__content {
        line-height: 20px;
    }

    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .demo-table-expand div .news {
        float: left;
        margin-right: 5px;
    }

    .demo-table-expand div .positive {
        background-color: #409eff;
        color: #FFFFFF;
    }

    .demo-table-expand div .negative {
        background-color: #11BE98;
        color: #FFFFFF;
    }

    .el-tooltip__popper {
        max-width: 1000px;
    }

    .demo-table-expand .el-form-item {
        /* margin-right: 0; */
        margin-bottom: 1px;
        margin-top: 1px;
        width: 100%;
    }

    .el-form--inline .el-form-item__content {
        width: 80%;
    }

    .el-button--primary {
        color: #fff;
        background-color: #409eff;
        border-color: #409eff
    }

    .el-button--primary:focus,
    .el-button--primary:hover {
        background: #66b1ff;
        border-color: #66b1ff;
        color: #fff
    }

    .el-button--primary.is-active,
    .el-button--primary:active {
        background: #3a8ee6;
        border-color: #3a8ee6;
        color: #fff
    }

    .el-button--primary:active {
        outline: 0
    }

    .el-button--primary.is-disabled,
    .el-button--primary.is-disabled:active,
    .el-button--primary.is-disabled:focus,
    .el-button--primary.is-disabled:hover {
        color: #fff;
        background-color: #a0cfff;
        border-color: #a0cfff
    }

    .el-button--primary.is-plain {
        color: #409eff;
        background: #ecf5ff;
        border-color: #b3d8ff
    }

    .el-button--primary.is-plain:focus,
    .el-button--primary.is-plain:hover {
        background: #409eff;
        border-color: #409eff;
        color: #fff
    }

    .el-button--primary.is-plain:active {
        background: #3a8ee6;
        border-color: #3a8ee6;
        color: #fff;
        outline: 0
    }

    .el-button--primary.is-plain.is-disabled,
    .el-button--primary.is-plain.is-disabled:active,
    .el-button--primary.is-plain.is-disabled:focus,
    .el-button--primary.is-plain.is-disabled:hover {
        color: #8cc5ff;
        background-color: #ecf5ff;
        border-color: #d9ecff
    }

    .el-button--medium {
        padding: 10px 20px;
        font-size: 14px;
        border-radius: 4px
    }

    .el-button--medium {
        padding: 10px 20px
    }

    .el-button--medium {
        padding: 10px
    }

    .el-button {
        -moz-user-select: none;
        -ms-user-select: none
    }

    .btn-large {
        margin-top: 20px;
        height: 50px;
        font-size: 22px;
        min-width: 200px;
        border-radius: 25px;
        padding: 0 34px;
        transition: all .2s ease
    }

    .btn-large,
    .btn-large:focus,
    .btn-large:hover,
    .btn-large:visited {
        color: #fff;
        background: linear-gradient(-15deg, #FF8F00, #FFBC31 69%);
        /*background: linear-gradient(-15deg,#75c0ff,#008bfa 69%); */
        box-shadow: 0 0 7px 3px #c7e6ff;
        border: none
    }

    .btn-large:focus,
    .btn-large:hover,
    .btn-large:visited {
        outline: 0
    }

    .btn-large:hover {
        background: linear-gradient(15deg, #FFBC31, #FF8F00 69%)
    }
</style>